import createIcon from '../../createIcon';

/**
 * @component @name SwitchRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNSAxNS4zOFY4LjYyTDE4Ljg4IDEyTDE1LjUgMTUuMzhaTTE0IDE5TDIxIDEyTDE0IDVWMTlaTTEwIDE5VjVMMyAxMkwxMCAxOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SwitchRight = createIcon('SwitchRight', [
  [
    'path',
    {
      d: 'M15.5 15.38V8.62L18.88 12L15.5 15.38ZM14 19L21 12L14 5V19ZM10 19V5L3 12L10 19Z',
      key: 'r0xkqr',
    },
  ],
]);

export default SwitchRight;
